/**
 * Library used to read the environment configuration within the
 * Hulu's CRA generated project
 */

'use strict';

const windowEnvironmentConfiguration = window.ENV_CONFIG;

if (typeof windowEnvironmentConfiguration === 'undefined') {
  throw new Error('Environment configuration not defined');
}

try {
  JSON.stringify(windowEnvironmentConfiguration);
} catch (e) {
  throw new Error('Environment configuration is invalid JSON');
}

module.exports = windowEnvironmentConfiguration;
